<template>
  <div
    v-if="!showSkinModal"
    id="messages-table"
    :class="[
      'h-auto transition-all duration-300',
      isMenuOpen ? 'md:ml-64' : 'md:ml-20'
    ]"
  >
    <div
      class="h-auto p-2"
      style="min-height: 100vh"
      v-if="skinFilt"
    >
      <div class="w-full max-w-full overflow-hidden  rounded-2xl">
        <div class="flex align-middle max-w-full mb-3 overflow-hidden rounded-xl">
          <button
            v-for="view in viewOptions"
            :key="view.value"
            class="flex-1 text-gray-700 p-3 border border-gray-200 bg-gray-50 transition-all duration-300 text-[clamp(13px,1vw,15px)] outline-none
                   hover:bg-[#386f99] hover:text-white hover:border-transparent hover:shadow-[0_4px_15px_rgba(56,111,153,0.3)] hover:opacity-90
                   focus:bg-[#386f99] focus:text-white focus:border-transparent focus:shadow-[0_4px_15px_rgba(56,111,153,0.3)] focus:opacity-90"
            :class="{ 
              '!bg-[#386f99] !text-white border-transparent shadow-[0_4px_15px_rgba(56,111,153,0.3)]': views === view.value 
            }"
            @click="views = view.value"
          >
            {{ view.label }}
          </button>
        </div>

        <MessagesManager
          :skinFilt="skinFilt"
          :category="category"
          :database="currentDb"
          v-if="views === 'MessagesManager' && skinFilt"
        />
        <BlockedPlayerManager
          :skinFilt="skinFilt"
          :category="category"
          :database="currentDb"
          v-else-if="views === 'BlockedPlayerManager' && skinFilt"
        />
        <ModerationChatManager
          :skinFilt="skinFilt"
          :category="category"
          :database="currentDb"
          v-else-if="views === 'ModerationChatManager' && skinFilt"
        />
      </div>
    </div>
    <div
      v-else
      class="flex items-center justify-content-center w-full"
      style="min-height: 50vh"
    >
      <Loader />
    </div>
  </div>

  
</template>

<script>
import { mapGetters } from "vuex";
import MessagesManager from "@/components/ChatPageComponent/MessagesManager.vue";
import BlockedPlayerManager from "@/components/ChatPageComponent/BlockedPlayerManager.vue";
import ModerationChatManager from "@/components/ChatPageComponent/ModerationChatManager.vue";
import Loader from "@/components/Loader.vue";
import { getActiveProviderSlug } from "@/helpers/provider";

export default {
  name: "ChatPageManager",
  components: {
    MessagesManager,
    BlockedPlayerManager,
    ModerationChatManager,
    Loader,
  },
  data() {
    return {
      views: "MessagesManager",
      viewOptions: [
        { label: "Chat", value: "MessagesManager" },
        { label: "Blocked Player", value: "BlockedPlayerManager" },
        { label: "Moderation", value: "ModerationChatManager" },
      ],
      skinFilt: false,
      showSkinModal: false,
      skinOptions: [],
      selectedSkin: null,
      dropdownOpen: false,
      searchQuery: "",
      animate: false,
    };
  },
  computed: {
    ...mapGetters(["allowedSkins", "isAdmin", "isMenuOpen", "chatSkinFilter", "skinStorage"]),
    category() {
      if (this.$route.params.category) return this.$route.params.category;
      if (this.$route.meta?.section) return this.$route.meta.section;
      if (this.$route.path.includes("/livecasino")) return "livecasino";
      if (this.$route.path.includes("/instant")) return "instant";
      return "slot";
    },
    currentDb() {
      const provider = getActiveProviderSlug ? getActiveProviderSlug() : "theearcasino";
      return `${provider}_${this.category}`;
    },
    filteredSkins() {
      if (!this.searchQuery) return this.skinOptions;
      const query = this.searchQuery.toLowerCase();
      return this.skinOptions.filter((skin) =>
        skin.toLowerCase().includes(query)
      );
    },
  },
  watch: {
    "$route.params.skinFilt": {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal !== "all") {
          this.skinFilt = parseInt(newVal) || newVal;
          this.showSkinModal = false;
        } else if (this.skinStorage) {
          this.skinFilt = parseInt(this.skinStorage) || this.skinStorage;
          this.showSkinModal = false;
        }
      },
    },
    showSkinModal(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.animate = true;
        }, 50);
      } else {
        this.animate = false;
      }
    },
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    selectSkin(skin) {
      this.selectedSkin = skin;
      this.dropdownOpen = false;
    },
    confirmSkinSelection() {
      if (!this.selectedSkin) return;
      const refId = this.selectedSkin.ref_id;
      this.skinFilt = refId;
      this.$store.commit("setSkinID", refId);
      this.$store.commit("setChatSkinFilt", refId);
      this.showSkinModal = false;
      const lang = this.$route.params.lang || "en";
      this.$router.push({
        name: "ChatPage",
        params: { lang, skinFilt: refId.toString() },
      });
    },
    closeModal() {
      this.showSkinModal = false;
    },
    closeIfClickedOutside(event) {
      return;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
  },
  async mounted() {
    this.skinOptions = this.allowedSkins ?? [];

    const activeSkin = this.$route.params.skinFilt || this.skinStorage;
    if (activeSkin && activeSkin !== "all") {
      this.skinFilt = parseInt(activeSkin) || activeSkin;
      this.showSkinModal = false;
    } else {
      this.skinFilt = false;
      document.body.style.overflow = "hidden";
      this.showSkinModal = true;
    }
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/style.scss";

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>